import React from 'react'
import JobInterviewContext from '../../../contexts/JobInterviewContext'
import StatusContext from '../../../contexts/StatusContext'
import { useState, useEffect } from "react";
import {NavBarJobInterview} from '../navbarjobinterview/NavBarJobInterview'
import {PromptWithIcon} from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import AIButton from '../aibutton/AIButton'
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
import { JobInterviewQuestions } from './JobInterviewQuestions'
import { DialogJobInterviewProgress } from './DialogJobInterviewProgress'

import "./jobinterview.css"

export const JobInterview = () => {

    const [submitprompt, setSubmitPrompt] = useState(false)

    let {
        uberTopics,
        onOpenSave,
        onClearChat,
        chatPrompt,
        setChatPrompt,
        onSubmitChat,
        status,
        
    } = React.useContext(JobInterviewContext);

    let {
        isMobile, 
        changeLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,
        focusRef,

        getAIName,
        getAIProvider,

        onClickAIButton,
       
    } = React.useContext(StatusContext);
   
    useEffect(() => {

    }, [])   

    const alertYes = () => {

      
        onClearChat()
        closeDialogBox()
        if (submitprompt)
        {
            setSubmitPrompt(false)
            onSubmitChat()
        }
    }

    const alertCancel = () => {
        closeDialogBox()
    }

    const handlePrompt = () => {
    
        setSubmitPrompt(true)
    
        if (uberTopics.some(arr => arr.length > 0)) 
        {
            openDialogBox()
        }
        else {
            setSubmitPrompt(false)
            onSubmitChat()
        }
    }
    
  return (

    <div className="homeContainer">
        {
            isMobile() &&
                <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
        }
             
        <NavBarJobInterview title={changeLanguage('jobinterview', 'navbartitle_2')}/>
              
        <JobInterviewQuestions />
        
        <hr className = 'separator'></hr>
        
        <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={handlePrompt} placeholdertext={changeLanguage('jobinterview','promptplaceholder')} clearPrompt={false}/>
        {
            (status) && <label className = 'statusLabel'>{status}</label>
        }
                
        <div ref={focusRef} className="mainButtons">
            <Stack direction="row" spacing={2}>
                {
                    !isMobile() &&
                        <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
                }
                       
                <PushButton onClick={openDialogBox} label =  {changeLanguage('assistant','clearall')} disablebutton= {(uberTopics.some(arr => arr.length > 0)) ? false : true}/>
              
                { 
                    (uberTopics.some(arr => arr.length > 0)) ? 
                    <PushButton onClick={onOpenSave} label={changeLanguage('jobinterview', 'save')} />
                     : null 
                }                          
            </Stack>   
            <AvailableCredits />
        </div> 

        <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("jobinterview", "note")}</label>
                   
        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('jobinterview', 'cleardata')}/>
        <DialogJobInterviewProgress />
        <DialogSelectModels />
     </div>
  )
}


